import Mock from "mockjs";
import user from "./user";

// Mock.mock(/\/login/, 'post', user.login);
Mock.mock(/\/loginCode/, "get", user.loginCode);
Mock.mock(/\/register/, "post", user.register);
Mock.mock(/\/citylist/, "get", user.citylist);



// WEBPACK FOOTER //
// ./src/mock/index.js